import ACTION_TYPES from "../actions/type.action";

const initialState = {
  assessments: [],
  assessmentdata: {
    setting: {
      assessmentId: null,
      createdOn: null,
      description: null,
      id: null,
      lastUpdatedOn: null,
      rubric: null,
      shuffleAnswerOptions: null,
      shuffleQuestions: null,
      theme: null,
      isWebView : false,
      isKtvAssessment : false
    },
  },
  questions: {},
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.CREATE_ASSESSMENT:
      return {
        ...state,
        assessments: [...payload],
      };

    case ACTION_TYPES.FETCH_ASSESSMENTS:
      return {
        ...state,
        assessments: [...payload],
      };

    case ACTION_TYPES.READ_ASSESSMENT:
      return {
        ...state,
        assessmentdata: payload,
      };
    case ACTION_TYPES.FILTER_ASSESSMENT:
      return {
        ...state,
        assessments: [...payload],
      };
    case ACTION_TYPES.READ_QUESTIONS:
      return {
        ...state,
        questions: [...payload],
      };
    case ACTION_TYPES.IS_WEB_VIEW:
      return {
        ...state,
        isWebView: payload,
      };
      case ACTION_TYPES.IS_KTV_ASSESSMENT_VIEW:
        return {
          ...state,
          isKtvAssessment: payload,
        };
      

    default:
      return state;
  }
};

export default reducer;
